import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartPulse } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

// Admin banner: a failed automatic repair or a gauge below 90 % for more than 2 minutes.
export const SelfHealBanner = () => {
  const { t } = useI18n();
  const [s, setS] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/admin/selfheal/summary").then(({ data }) => alive && setS(data)).catch(() => {});
    load();
    const id = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);
  if (!s?.alert) return null;
  return (
    <div className="border-b border-red-500/40 bg-red-950/70" role="alert" data-testid="selfheal-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-1 px-4 py-2 text-sm text-red-100 sm:px-8">
        <HeartPulse className="h-4 w-4 shrink-0" />
        <span className="min-w-0 font-semibold">{t("heal.alertTitle")} — <bdi data-testid="selfheal-banner-gauge">{s.gauge.toFixed(4)} %</bdi></span>
        <Link to="/admin/sante" className="underline underline-offset-4" data-testid="selfheal-banner-link">{t("heal.open")}</Link>
      </div>
    </div>
  );
};
